"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferencePrice = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const referencePriceJsonMapping = {
    Id: 'id',
    schemaVersion: 'schemaVersion',
    ReferenceArtNr: 'referenceArtNr',
    UpdateTimeStamp: 'updateTimeStamp',
    CountryCode: 'countryCode',
    Price: 'price',
    Currency: 'currency',
};
class ReferencePrice {
    static fromJson(json) {
        const referencePrice = new ReferencePrice();
        referencePrice.fromJson(json);
        return referencePrice;
    }
    fromJson(json) {
        echain_shared_oo_1.Serialization.fromJson(json, this, referencePriceJsonMapping);
    }
    toJson() {
        return echain_shared_oo_1.Serialization.toJson(this, referencePriceJsonMapping);
    }
}
exports.ReferencePrice = ReferencePrice;
//# sourceMappingURL=ReferencePrice.js.map